<template>
	<div id="app">
		<layout-template></layout-template>
	</div>
</template>
<script>

import LayoutTemplate from '@/components/Layout/layoutTemplate.vue'
import UserService from './services/user.service'

export default {
  name: 'App',
  data: function() {
    return {
      RefreshTokenInterval: process.env.VUE_APP_RefreshTokenIntervalInMinutes * 60 * 1000,
    }
  },
  components: {
    LayoutTemplate
  },
  watch: {
    $route (to) {
      this.onRouteChange(to)
    }
  },
  mounted () {
    this.initiateRefreshToken()
  },
  methods: {
    onRouteChange (route) {
      document.title = route.meta.title || 'eznatal | Support'
    },
    initiateRefreshToken: function (){
      let vm = this
      vm.refreshToken()
      setInterval(() => { vm.refreshToken() }, this.RefreshTokenInterval)
    },
    refreshToken: function () {
      if (this.$store.state.auth.loggedInState) {
        UserService.refreshAccessToken().then(
          response => {
            if (response && response.data.Status) {
              this.$store.dispatch('refreshAccessToken', response.data.Object.AccessToken)
            } else {
              this.$store.dispatch('unauthorizedAction')
            }
          },
		  error => {
			  console.log(error)
			  this.$store.dispatch('unauthorizedAction')
		  }
        )
      }
    }
  }
}
</script>
